import fetchWithAuth from "../middlewares/fetchWithAuth";
import { API_BASE_URL } from "../config";

const APP_INSIGHTS_ERROR = "Los datos de analytics requieren Application Insights configurado.";

async function handleAnalyticsResponse(res) {
  if (res.ok) {
    return res.json();
  }

  let message = `Error ${res.status}`;

  try {
    const contentType = res.headers.get("content-type") || "";
    if (contentType.includes("application/json")) {
      const payload = await res.json();
      message = payload?.message || payload?.error || message;
    } else {
      const text = await res.text();
      message = text || message;
    }
  } catch {
    // Ignorar errores de parsing y usar el mensaje por defecto.
  }

  const error = new Error(res.status === 500 ? APP_INSIGHTS_ERROR : message);
  error.status = res.status;
  throw error;
}

export async function getUsageData(timeRange = '7d', userId = null, navigate) {
  const params = new URLSearchParams({ timeRange });
  if (userId) params.append('userId', userId);

  const res = await fetchWithAuth(
    `${API_BASE_URL}/analytics/usage?${params}`,
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
    navigate
  );

  return handleAnalyticsResponse(res);
}

export async function getUsersAnalytics(timeRange = '7d', navigate) {
  const res = await fetchWithAuth(
    `${API_BASE_URL}/analytics/users?timeRange=${timeRange}`,
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
    navigate
  );

  return handleAnalyticsResponse(res);
}
